import { HelpContent } from '../../../UI-Lib/Help-Tooltip';

export const IMPORT_SPECIFICATION_LIST_HELP: HelpContent[] = [
    {
        helpContentId: 'import-specification-list.include-disabled',
        tooltipText: 'Include disabled specifications.',
        hasIcon: true
    }
];
